import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const HomeJa = lazy(() => import('../pages/home-ja/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/ja',
    element: <HomeJa />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
